import isEmpty from 'lodash/isEmpty';
import { replace } from 'redux-first-router';

import { querySel } from '@location';
import { ROUTE_ACTIVITIES, emptyObj } from '@shared';
import { setOrganization } from '@shared/duck/actions';
import { organizationPositionsSel } from '@shared/duck/selectors/general.selectors';
import { newPermissions } from '@shared/newPermissions';

import { ActivitiesPage, ActivitiesPlaceholder } from './components';

const routes = {
  [ROUTE_ACTIVITIES]: {
    path: '/activities',
    Component: ActivitiesPage,
    Placeholder: ActivitiesPlaceholder,
    titleId: 'page.activities',
    permission: newPermissions.VIEW_ACTIVITY_PAGE,
    thunk: (dispatch, getState) => {
      const state = getState();
      const positions = organizationPositionsSel(state);
      const { organizationGuid = '' } = querySel(state) || emptyObj;
      if (!isEmpty(organizationGuid) && !isEmpty(positions)) {
        const foundedPosition = positions.find(
          p => p.organizationGuid === organizationGuid,
        );
        replace('/activities');
        if (foundedPosition) {
          dispatch(
            setOrganization({
              guid: foundedPosition.organizationGuid,
              programType: foundedPosition.programType,
              parentOrgGuid: foundedPosition.organizationGuid,
            }),
          );
        }
      }
    },
  },
};

export default routes;
